var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tagContent", attrs: { id: "page_Container" } },
    [
      _c(
        "div",
        { staticClass: "page" },
        [
          _vm.show
            ? _c(
                "van-tabs",
                {
                  attrs: { swipeable: "", sticky: "" },
                  on: { click: _vm.tagClick },
                  model: {
                    value: _vm.active,
                    callback: function($$v) {
                      _vm.active = $$v
                    },
                    expression: "active"
                  }
                },
                _vm._l(_vm.tagList, function(item, index) {
                  return _c("van-tab", {
                    key: index,
                    attrs: { title: item.tagName }
                  })
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "main-container tag-list",
              attrs: { id: "main-container" }
            },
            [
              _c(
                "van-pull-refresh",
                {
                  on: { refresh: _vm.onRefresh },
                  model: {
                    value: _vm.isLoading,
                    callback: function($$v) {
                      _vm.isLoading = $$v
                    },
                    expression: "isLoading"
                  }
                },
                [
                  _c(
                    "van-list",
                    {
                      attrs: {
                        finished: _vm.finished,
                        "finished-text": "没有更多了",
                        offset: 1
                      },
                      on: { load: _vm.onLoad },
                      model: {
                        value: _vm.ploading,
                        callback: function($$v) {
                          _vm.ploading = $$v
                        },
                        expression: "ploading"
                      }
                    },
                    [
                      !_vm.isShow
                        ? _c(
                            "div",
                            _vm._l(_vm.goodsList, function(good) {
                              return _c(
                                "div",
                                {
                                  key: good.id,
                                  on: {
                                    click: function($event) {
                                      _vm.godetail(good)
                                    }
                                  }
                                },
                                [_c("goodCommon", { attrs: { good: good } })],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.isShow
                ? _c("div", { staticClass: "nogood" }, [
                    _c("img", {
                      attrs: {
                        src: require("../assets/img/myCenter/noList.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("暂无商品")])
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }